module.exports = __webpack_public_path__ + "static/media/LogoVitalbookWhite.d6c08029.svg";